import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import DashboardLayout from "../../../components/DashboardLayout";
import { setCurrentProject } from "../../../redux/project/projectSlice";
import { projectsService } from "../../../services/projects";
import { sitePath } from "../../../utils/urls";
import General from "./General";
import Management from "./Management";
import Seo from "./Seo";
import Specs from "./Specs";

const SettingsIndex = (authProps) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { siteSlug } = useParams();
  const project = useSelector((state) => state.project.currentProject);
  // List rows omit site_plan / memberships; hydrate detail once for all settings tabs.
  useEffect(() => {
    if (!project?.hash) return;
    projectsService.getProject(project.hash, (response) => {
      dispatch(setCurrentProject(response.data));
    });
  }, [project?.hash, dispatch]);
  const tabs = [
    { id: "general", label: "General" },
    { id: "specs", label: "Specs" },
    { id: "indexing", label: "Indexing" },
    { id: "management", label: "Management" },
  ];
  const active = tabs.find((tab) => location.pathname.includes(`/${tab.id}/`))?.id || "general";
  const navConfig = tabs.map((tab) => ({
    id: tab.id,
    label: tab.label,
    to: sitePath(siteSlug, `settings/${tab.id}/`),
    active: active === tab.id,
  }));

  return (
    <DashboardLayout title="Settings" currentUser={authProps.currentUser} navConfig={navConfig}>
      <Routes>
        <Route path="general/" element={<General currentUser={authProps.currentUser} />} />
        <Route path="specs/" element={<Specs />} />
        <Route path="indexing/" element={<Seo />} />
        <Route path="management/" element={<Management />} />
        <Route path="" element={<Navigate to="general/" replace />} />
        <Route path="*" element={<Navigate to="general/" replace />} />
      </Routes>
    </DashboardLayout>
  );
};

export default SettingsIndex;
